import pbiService from '@/services/pbi.service';
import commonService from '@/services/common.service';
import config from '@/config/prod.env';

const actions = {
    async getPBIDatasets({ dispatch }, workspaceId) {
        return await pbiService.getDatasets(workspaceId);
    },

    async refreshDataset({ dispatch }, datasetId) {
        let res = await pbiService.refreshDataset(datasetId);
        if(res.isOk) {
            if(res.data && res.data.data) {
                dispatch("alert/success", "Refresh thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },
    
    async getRefreshSchedule({ dispatch }, datasetId) {
        return await pbiService.getRefreshSchedule(datasetId);
    },

    async updateRefreshSchedule({ dispatch }, obj) {
        let res = await pbiService.updateRefreshSchedule(obj.datasetId, obj.times, obj.enabled);
        if(res.isOk) {
            if(res.data && res.data.data) {
                dispatch("alert/success", "Lập lịch thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async getRefreshHistory({ dispatch }, datasetId) {
        return await pbiService.getRefreshHistory(datasetId);
    },
};

export const dataset = {
    namespaced: true,
    actions
};